import App from './NewNomination.vue'

export default function mountApp(Vue, targetId) {
  if (!document.getElementById(targetId)) return
  new Vue({
    render: h => h(App),
  }).$mount(`#${targetId}`)
}
